var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessengerApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 0C4.36749 0 0 4.12749 0 9.69997C0 12.615 1.195 15.135 3.13999 16.875C3.30249 17.02 3.40249 17.225 3.40749 17.445L3.46249 19.2249C3.46649 19.3559 3.50261 19.4839 3.56766 19.5976C3.6327 19.7114 3.7247 19.8074 3.83554 19.8773C3.94639 19.9471 4.07271 19.9887 4.20339 19.9983C4.33406 20.008 4.4651 19.9853 4.58499 19.9324L6.56998 19.0574C6.73748 18.9824 6.92748 18.9699 7.10498 19.0174C8.01748 19.2674 8.98747 19.4024 9.99997 19.4024C15.6325 19.4024 19.9999 15.275 19.9999 9.70247C19.9999 4.12999 15.6325 0 9.99997 0Z",
    fill: "url(#paint0_radial_606_60473)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99544 12.5372L6.93293 7.87725C7.04343 7.7018 7.18911 7.55117 7.36076 7.43487C7.53242 7.31856 7.72632 7.23911 7.93023 7.20152C8.13414 7.16393 8.34363 7.16903 8.54547 7.21649C8.74732 7.26395 8.93713 7.35274 9.10292 7.47725L11.4404 9.22975C11.5448 9.30787 11.6717 9.34989 11.8021 9.34944C11.9324 9.34899 12.0591 9.30609 12.1629 9.22725L15.3179 6.83225C15.7379 6.51225 16.2879 7.01725 16.0079 7.46475L13.0679 12.1222C12.9574 12.2977 12.8117 12.4483 12.6401 12.5646C12.4684 12.6809 12.2745 12.7604 12.0706 12.798C11.8667 12.8356 11.6572 12.8305 11.4554 12.783C11.2535 12.7355 11.0637 12.6468 10.8979 12.5222L8.56042 10.7697C8.45607 10.6916 8.32911 10.6496 8.19876 10.6501C8.0684 10.6505 7.94174 10.6934 7.83793 10.7722L4.68293 13.1672C4.26294 13.4872 3.71294 12.9847 3.99544 12.5372Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_606_60473",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.34999 19.9999) scale(21.9999 21.9999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerApp);
export default __webpack_public_path__ + "static/media/MessengerApp.2a865c6264c43db409535b03504bb084.svg";
export { ForwardRef as ReactComponent };